import React, { useEffect, useMemo, useState } from "react";
import NavBar from "../../../component/b2b/navBar/b2bNavBar";
import Sidebar from "../../../component/b2b/sideBar/b2bSideBar";
import { useMyContext } from "../../../context/MyContext";
import { Link } from "react-router-dom";
import {
  Base_Url,
  b2bdashboard,
  b2bAllShipmentList,
  shipmentlabel,
  cancleOrder,
  userdata,
  Url_For_View_Document
} from "../../../config/config";

import {
  ResponsiveContainer,
  AreaChart,
  Area,
  CartesianGrid,
  Tooltip,
  XAxis,
  YAxis,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar
} from "recharts";

import {
  Search,
  ChevronLeft,
  ChevronRight,
  Download,
  Package,
  Truck,
  Wallet,
  AlertTriangle
} from "lucide-react";

import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { motion } from "framer-motion";

export default function DashBoard() {
  const { isToggleSidebar } = useMyContext();

  const token = localStorage.getItem("token");
  const cusid = localStorage.getItem("cus_id");

  const [stats, setStats] = useState({});
  const [chartData, setChartData] = useState([]);
  const [shipments, setShipments] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  const rowsPerPage = 10;

  useEffect(() => {
    loadDashboard();
    loadOrders();
  }, []);

  const loadDashboard = async () => {
    const res = await fetch(`${Base_Url}${b2bdashboard}`, {
      headers: {
        token,
        cus_id: cusid,
        "Content-Type": "application/json"
      }
    });

    const data = await res.json();
    setStats(data?.data || {});
    setChartData(data?.chartData?.monthlyData || []);
  };

  const loadOrders = async () => {
    const res = await fetch(
      `${Base_Url}${b2bAllShipmentList}/Pending`,
      {
        headers: {
          token,
          cus_id: cusid,
          "Content-Type": "application/json"
        }
      }
    );

    const data = await res.json();
    setShipments(data?.data || []);
  };

  const cancelOrder = async (id) => {
    const res = await fetch(
      `${Base_Url}${cancleOrder}/${id}`,
      {
        headers: {
          token,
          cus_id: cusid,
          "Content-Type": "application/json"
        }
      }
    );

    if (res.ok) {
      toast.success("Cancelled");
      loadOrders();
    }
  };

  const handleDownload = async () => {
    const ids = shipments.map((x) => x.order_id);

    const res = await fetch(
      `${Base_Url}${shipmentlabel}`,
      {
        method: "POST",
        headers: {
          token,
          cus_id: cusid,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          order_ids: ids
        })
      }
    );

    const data = await res.json();

    if (data.status === "SUCCESS") {
      window.open(
        Url_For_View_Document + data.DownloadLink,
        "_blank"
      );
    }
  };

  const filtered = useMemo(() => {
    return shipments.filter((item) => {
      const customer =
        JSON.parse(item.dropoff_location || "{}")?.consignee_name || "";

      return (
        item.order_id?.toLowerCase().includes(search.toLowerCase()) ||
        customer.toLowerCase().includes(search.toLowerCase())
      );
    });
  }, [shipments, search]);

  const totalPages = Math.ceil(filtered.length / rowsPerPage);

  const rows = filtered.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const cards = [
    {
      title: "Orders",
      value: stats.total_order || 0,
      icon: Package,
      color: "from-cyan-500 to-blue-600"
    },
    {
      title: "Delivered",
      value: stats.total_delivered || 0,
      icon: Truck,
      color: "from-emerald-500 to-green-600"
    },
    {
      title: "Revenue",
      value: stats.cod_remittance || "₹0",
      icon: Wallet,
      color: "from-orange-500 to-red-500"
    },
    {
      title: "Issues",
      value: stats.total_rto || 0,
      icon: AlertTriangle,
      color: "from-violet-500 to-purple-700"
    }
  ];

  const pieData = [
    { name: "Delivered", value: stats.total_delivered || 0 },
    { name: "Pending", value: stats.total_order || 0 },
    { name: "RTO", value: stats.total_rto || 0 }
  ];


  const formatIndianCurrency = (value) => {
    if (!value) return "0";
    let num = parseFloat(value);
    if (num >= 10000000) {
      return (num / 10000000).toFixed(1).replace(/\.0$/, '') + "Cr";
    }
    else if (num >= 100000) {
      return (num / 100000).toFixed(1).replace(/\.0$/, '') + "L";
    }
    else if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, '') + "K";
    }
    return num.toLocaleString('en-IN');
  };

  return (
    <div className="b2b-dashboard-page h-screen flex flex-col bg-slate-100 dark:bg-darkmodeColor">
      <NavBar />

      <div className="flex flex-1 overflow-hidden">

        {isToggleSidebar && (
            <div className="w-64 bg-white border-r border-slate-200 dark:border-white/10 dark:bg-darkmodeColor">
            <Sidebar />
          </div>
        )}

        <div className="flex-1 overflow-auto p-3 sm:p-5">
          <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">

            {cards.map((item, i) => {
              const Icon = item.icon;

              return (
                <motion.div
                  key={i}
                  whileHover={{
                    y: -5,
                    scale: 1.02
                  }}
                  className={`rounded-3xl p-5 text-white bg-gradient-to-br ${item.color} shadow-xl`}
                >
                  <div className="flex justify-between">
                    <Icon size={18} />
                    <span className="text-xs">
                      Live
                    </span>
                  </div>

                  <p className="text-xs mt-4 opacity-90">
                    {item.title}
                  </p>

                  <h2 className="text-3xl font-bold mt-2">
                    {item.value}
                  </h2>
                </motion.div>
              );
            })}

          </div>

          <div className="grid grid-cols-1 xl:grid-cols-4 gap-4 mt-5">
              <div className="xl:col-span-2 bg-white rounded-lg p-5 shadow-sm border border-slate-200 dark:border-white/10 dark:bg-[rgba(1,14,78,0.96)] dark:text-white">

                <div className="flex justify-between mb-4">
                  <h2 className="font-semibold">Revenue Growth</h2>
                  <span className="text-blue-600 text-sm dark:text-blue-300">Monthly</span>
                </div>

                <div className="h-72">
                  <ResponsiveContainer width="100%" height="100%">
                    <AreaChart data={chartData}>
                      <defs>
                        <linearGradient id="flow" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="#3b82f6" stopOpacity={0.7} />
                          <stop offset="100%" stopColor="#3b82f6" stopOpacity={0} />
                        </linearGradient>
                      </defs>

                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" tick={{ fontSize: 10 }} />

                      {/* ✅ Main Change Here */}
                      <YAxis
                        tick={{ fontSize: 10 }}
                        tickFormatter={formatIndianCurrency}
                      />

                      <Tooltip formatter={(value) => [formatIndianCurrency(value), "Revenue"]} />

                      <Area
                        dataKey="total_sales"
                        stroke="#2563eb"
                        fill="url(#flow)"
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                </div>
              </div>

              <div className="bg-white rounded-lg p-5 shadow-sm border border-slate-200 dark:border-white/10 dark:bg-[rgba(1,14,78,0.96)] dark:text-white">

                <h2 className="font-semibold mb-4">
                  Orders Status
                </h2>

                <div className="h-72">
                  <ResponsiveContainer>
                    <PieChart>
                      <Pie
                        data={pieData}
                        dataKey="value"
                        innerRadius={55}
                        outerRadius={90}
                      >
                        <Cell fill="#22c55e" />
                        <Cell fill="#3b82f6" />
                        <Cell fill="#ef4444" />
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>
                </div>

              </div>

              <div className="bg-white rounded-lg p-5 shadow-sm border border-slate-200 dark:border-white/10 dark:bg-[rgba(1,14,78,0.96)] dark:text-white">

                <h2 className="font-semibold mb-4">
                  Shipments
                </h2>

                <div className="h-72">
                  <ResponsiveContainer>
                    <BarChart data={chartData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" tick={{ fontSize: 10 }} />
                      <YAxis tick={{ fontSize: 10 }} />
                      <Tooltip />
                      <Bar
                        dataKey="total_sales"
                        radius={[6, 6, 0, 0]}
                        fill="#8b5cf6"
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>

              </div>

          </div>

          <div className="bg-white rounded-lg shadow-sm border border-slate-200 mt-5 p-4 sm:p-5 dark:border-white/10 dark:bg-[rgba(1,14,78,0.96)] dark:text-white">

            <div className="flex justify-between items-center mb-4">

              <h2 className="text-lg font-semibold">
                Orders List
              </h2>

              <Link
                to="/b2b/shipments/list"
                className="text-blue-600 text-sm font-semibold dark:text-blue-300"
              >
                View All
              </Link>

            </div>

            <div className="relative mb-4">

              <Search
                size={15}
                className="absolute left-3 top-3 text-slate-400"
              />

              <input
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1);
                }}
                placeholder="Search order or customer..."
                className="w-full border border-slate-200 rounded-lg pl-10 pr-3 py-2 text-sm outline-none focus:border-customPurple focus:ring-2 focus:ring-customPurple/20 dark:border-white/10 dark:bg-[rgba(1,14,78,0.96)] dark:text-white dark:placeholder-slate-400"
              />

            </div>

            <div className="overflow-auto custom-scrollbar">

              <table className="w-full text-xs">

                <thead>
                  <tr className="text-left text-slate-500 border-b border-slate-200 dark:border-white/10 dark:text-slate-300">
                    <th className="p-3">Order</th>
                    <th className="p-3">User</th>
                    <th className="p-3">Customer</th>
                    <th className="p-3">Amount</th>
                    <th className="p-3">Status</th>
                    <th className="p-3">Date</th>
                    <th className="p-3">Action</th>
                  </tr>
                </thead>

                <tbody>

                  {rows.map((item, i) => {
                    const customer =
                      JSON.parse(item.dropoff_location || "{}");

                    return (
                      <tr
                        key={i}
                        className="border-b border-slate-100 hover:bg-purple-50/50 dark:border-white/10 dark:hover:bg-white/5"
                      >
                        <td className="p-3 font-semibold text-blue-600 dark:text-blue-300">
                          {item.order_id}
                        </td>

                        <td className="p-3">
                          {item.user_id}
                        </td>

                        <td className="p-3">
                          <p>{customer?.consignee_name}</p>
                          <p className="text-slate-400 dark:text-slate-500">
                            {customer?.phone}
                          </p>
                        </td>

                        <td className="p-3">
                          ₹{item.cod_amount}
                        </td>

                        <td className="p-3">
                          <span className="px-2 py-1 rounded-full bg-blue-100 text-blue-700">
                            {item.status}
                          </span>
                        </td>

                        <td className="p-3">
                          {item.created_at?.split(" ")[0]}
                        </td>

                        <td className="p-3">
                          <button
                            onClick={() =>
                              cancelOrder(item.order_id)
                            }
                            className="px-3 py-1 rounded-lg bg-red-500 text-white transition-colors hover:bg-red-600 disabled:opacity-50"
                          >
                            Cancel
                          </button>
                        </td>

                      </tr>
                    );
                  })}

                </tbody>

              </table>

            </div>

            <div className="flex justify-between items-center mt-4">

              <p className="text-xs text-slate-500 dark:text-slate-400">
                Page {page} of {totalPages || 1}
              </p>

              <div className="flex gap-2">

                <button
                  onClick={() =>
                    setPage(page - 1)
                  }
                  disabled={page === 1}
                  className="border border-slate-200 px-3 py-1 rounded-lg transition-colors hover:border-customPurple hover:text-customPurple disabled:cursor-not-allowed disabled:opacity-40 dark:border-white/10 dark:hover:border-customPurple"
                >
                  <ChevronLeft size={14} />
                </button>

                <button
                  onClick={() =>
                    setPage(page + 1)
                  }
                  disabled={page === totalPages}
                  className="border border-slate-200 px-3 py-1 rounded-lg transition-colors hover:border-customPurple hover:text-customPurple disabled:cursor-not-allowed disabled:opacity-40 dark:border-white/10 dark:hover:border-customPurple"
                >
                  <ChevronRight size={14} />
                </button>

              </div>

            </div>

          </div>

        </div>

      </div>
    </div>
  );
}
